import {showNotification} from 'platform/components';
import {Show, Link} from 'platform/foundation';

import {isNotNil} from 'ramda';

import {useGetRentalOrderQuery} from '@dms/api/rental';
import i18n from '@dms/i18n';
import {vehiclesRoutes} from '@dms/routes';

import {composePath, TestIdProps, useNavigate} from 'shared/web';

interface RentalVehicleProps extends TestIdProps {
  recordId: string;
}

export const RentalVehicle = (props: RentalVehicleProps) => {
  const navigate = useNavigate();

  const {data: rentalOrder} = useGetRentalOrderQuery({rentalOrderId: props.recordId});
  const hasAssignedVehicle = isNotNil(rentalOrder?.rentalVehicleId);

  const handleNavigate = () => {
    if (!hasAssignedVehicle) {
      showNotification.error();
      return;
    }

    navigate(composePath(vehiclesRoutes.detail, {params: {id: rentalOrder?.rentalVehicleId}}));
  };

  return (
    <Show when={hasAssignedVehicle}>
      <Link
        size="small"
        leftIcon="sidebar/vehicles"
        title={i18n.t('page.rentalOrder.labels.vehicleDetail')}
        onClick={handleNavigate}
      />
    </Show>
  );
};
